export default "__VITE_ASSET__VC4TFxF$__"